type ConfirmAction = () => void | Promise<void>;

/**
 * Runs a confirmation callback while preserving sync user gestures
 * (e.g. window.open). Only async confirms toggle pending.
 *
 * @param onConfirm - Confirm handler (sync or async)
 * @param setPending - Pending flag setter for async work
 * @returns Promise when onConfirm is async; otherwise undefined
 */
const invokeConfirmAction = (
	onConfirm: ConfirmAction,
	setPending: (pending: boolean) => void,
): void | Promise<void> => {
	const result = onConfirm();

	if (result instanceof Promise) {
		setPending(true);
		return result.finally(() => {
			setPending(false);
		});
	}
};

export { invokeConfirmAction };
